import React from 'react'

import { FormLabel } from '@chakra-ui/react'

const CustomFormLabel = props => (
  <FormLabel
    {...props}
    fontWeight="bold"
    color="brand.blue"
  />
)

export default CustomFormLabel
